import React from 'react';

/**
 * Skeleton component for loading metrics
 */
const MetricSkeleton = () => (
  <div className="animate-pulse">
    <div className="h-4 bg-white/20 rounded w-3/4 mb-1"></div>
  </div>
);

export default MetricSkeleton;